import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Status } from 'src/app/shared/IFE/components/file-picker/models/imageInfo.interface';

@Component({
  selector: 'app-multiple-image-picker',
  templateUrl: './multiple-image-picker.component.html',
  styleUrls: ['./multiple-image-picker.component.scss'],
})
export class MultipleImagePickerComponent {
  @Input() images: UntypedFormArray;
  @Input() baseUrl: string;
  @Input() numberOfImages: number;
  @Output() removeImage: EventEmitter<number> = new EventEmitter<number>();
  @Output() addNewImage: EventEmitter<any> = new EventEmitter<any>();

  imageDetailsVisible = [true, true, true];
  status = Status.init;

  constructor(private toastr: ToastrService, private translate: TranslateService) {}

  toggleImageDetails(index: number) {
    this.imageDetailsVisible[index] = !this.imageDetailsVisible[index];
  }

  setStatus(status: Status) {
    this.status = status;
    // auto collapse all images instead of last one
    if (window.matchMedia('(max-width: 768px)').matches) {
      this.images.controls.forEach((control, index) => {
        this.imageDetailsVisible[index] = false;
      });
      this.imageDetailsVisible[this.images.length - 1] = true;
    }
  }

  sendImage(event) {
    // 10Mib
    const maxFileSize = 10485760;
    const reader = new FileReader();
    const imageFile = event.target.files[0];
    if (imageFile.size >= maxFileSize) {
      this.toastr.error(this.translate.instant('errorMessages.imageToLarge'));
      return;
    }

    this.setStatus(Status.loading);
    reader.addEventListener('load', (loadEvent: any) => {
      this.addNewImage.emit([imageFile, this.setStatus.bind(this)]);
      reader.removeEventListener('load', null);
    });

    reader.readAsDataURL(imageFile);
    event.target.value = '';
  }

  remove(index: number) {
    this.removeImage.emit(index);
  }

  addNewButtonVisible(): boolean {
    return this.images.length < this.numberOfImages;
  }
}
